<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import downloader from '@/mixins/downloader';

export default {
  name: 'PrivacyAuditListItem',
  mixins: [downloader],
  props: {
    privacyAudit: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    formattedStartDate() {
      return this.privacyAudit.startDate ? moment(this.privacyAudit.startDate).format('DD.MM.YYYY') : '';
    },
    formattedEndDate() {
      return this.privacyAudit.endDate ? moment(this.privacyAudit.endDate).format('DD.MM.YYYY') : '';
    },
    ...mapGetters('app', ['auth']),
  },
  methods: {
    ...mapActions('privacyAuditList', ['downloadReport', 'downloadReportWord']),
    ...mapActions('privacyAuditList', { fetchData: 'fetchPrivacyAuditList' }),
    onDelete() {
      this.$emit('delete', this.privacyAudit);
    },
    _downloadReport() {
      return this.downloadReport(this.privacyAudit.id)
        .then((response) => {
          this.getDownloadContent(response, 'audit_report.pdf');
        }).catch((error) => {
          console.log(`Fehler: ${error.response}`);
          this.showErrorMessage('Beim Erstellen des Berichts ist ein Fehler aufgetreten.');
        });
    },
    downloadWordReport() {
      return this.downloadReportWord(this.privacyAudit.id)
        .then((response) => {
          this.getDownloadContent(response, 'audit_report.docx');
        }).catch((error) => {
          console.log(`Fehler: ${error.response}`);
          this.showErrorMessage('Beim Erstellen des Berichts ist ein Fehler aufgetreten.');
        });
    },
  },
};
</script>

<template>
  <tr>
    <td>{{ privacyAudit.isFinished ? 'ja' : 'nein' }}</td>
    <td>
      <router-link :to="`/privacyAudit/show/${privacyAudit.id}`">
        {{ privacyAudit.name }}
      </router-link>
    </td>
    <td>{{ privacyAudit.auditor }}</td>
    <td>{{ formattedStartDate }}</td>
    <td>{{ formattedEndDate }}</td>
    <td >
      <v-tooltip bottom>
        <v-btn v-if="auth.hasDownloadRights"
               @click.native="downloadWordReport" flat icon slot="activator">
          <v-icon small>sim_card_download</v-icon>
        </v-btn>
        <span>Bericht herunterladen(Word Format)</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn v-if="auth.hasDownloadRights"
               @click.native="_downloadReport" flat icon slot="activator">
          <v-icon small>cloud_download</v-icon>
        </v-btn>
        <span>Bericht herunterladen</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn
          v-if="auth.hasDeleteRights"
          slot="activator"
          :disabled="privacyAudit.isDelete"
          flat icon
          @click.native="onDelete"
        >
          <v-icon small>delete</v-icon>
        </v-btn>
        <span>Löschen</span>
      </v-tooltip>
    </td>
  </tr>
</template>
